'stocktend_home'.click()
'helper'.trashAll('Inventory')
'helper'.trashAll('POReceipt')
'helper'.trashAll('PO')
'helper'.trashAll('POLine')
'helper'.trashAll('UserFilter')
'helper'.trashAll('Supplier')
'helper'.trashAll('Facet')
'helper'.trashAll('Template')
'helper'.trashAll('Adjustment')
'helper'.clearWCStockLevels()
'helper'.clearWCOrders()
'helper'.addWCOrder({product: 'Polo (P01)', quantity: 1, orderDate: global.todayLocal(), status: 'wc-processing', setModDateToOrder: true})
'helper'.addWCOrder({product: 'Cap (C01)', quantity: 1, orderDate: global.todayLocal().incDays(-7 * 5), status: 'wc-processing', setModDateToOrder: true})
'helper'.addWCOrder({product: 'Hoodie (H01)', quantity: 1, orderDate: global.todayLocal().incDays(-7 * 13), status: 'wc-processing', setModDateToOrder: true})
'helper'.simulateBrowserRefresh()
'Sales and Invoices'.click()
  'mainTable'.shouldHaveCount(2)
  'Show Older Sales'.click()
    'mainTable'.shouldHaveCount(3)
    'mainTable./Polo (P01)/.Active'.shouldEqual('Yes')
    'mainTable./Cap (C01)/.Active'.shouldEqual('Yes')
    'mainTable./Hoodie (H01)/.Active'.shouldEqual('No')
    'Back'.click()
  'Back'.click()
'stocktend_settings'.click()
  'Treat Old Incomplete WC Orders As Inactive'.shouldEqual('Yes')
  'Treat Old Incomplete WC Orders As Inactive'.enter('No')
  'OK'.click()
'helper'.simulateBrowserRefresh()
'Sales and Invoices'.click()
  'mainTable'.shouldHaveCount(3)
  'Show Older Sales'.click()
    'mainTable./Hoodie (H01)/.Active'.shouldEqual('Yes')
    'Back'.click()
  'Back'.click()
'helper'.trashAll('Inventory')
'helper'.clearWCOrders()
'helper'.clearWCStockLevels()
'helper'.simulateBrowserRefresh()
'stocktend_suppliers'.click()
  'Add'.click()
    'Name'.enter('Acme')
    'OK'.click()
  'Back'.click()
'stocktend_inventory'.click()
  'Customize'.click()
    'Add Field'.click()
      'Get Value From'.enter('Inventory.mainSupplier')
      'Caption'.enter('Supplier')
      'OK'.click()
    'Back'.click()
  'mainTable./Hoodie (H01)/.Edit Product'.click()
    'Add Supplier'.click()
      'Supplier'.enter('Acme')
      'OK'.click()
    'OK'.click()
  'mainTable./Hoodie (H01)/.Supplier'.shouldEqual('Acme')
  'Back'.click()
'helper'.simulateBrowserRefresh()
'stocktend_inventory'.click()
  'mainTable./Hoodie (H01)/.Supplier'.shouldEqual('Acme')
  'Add Filter'.click()
    'Filter Name'.enter('Supplier Acme')
    'Add Line'.click()
      'Field Name'.enter('mainSupplier')
      'operator'.enter('starts with')
      'expression'.enter("Acme")
      'OK'.click()
    'OK'.click()
  'mainTable'.shouldHaveCount(2)
  'mainTable.1.Supplier'.shouldEqual('Acme')
  'Manage Filters'.click()
    'mainTable./Supplier Acme/.Trash'.click()
    'mainTable./Supplier Acme/.Really Trash?'.click()
    'Back'.click()
  'Add Filter'.click()
    'Filter Name'.enter('Bad Filter')
    'Add Line'.click()
      'Field Name'.enter('uniqueName')
      'operator'.enter('contains')
      'expression'.enter("rubbish'jhkjhkjh")
      'OK'.click()
    'OK'.click()
    'messageDialogText'.shouldEqual("WARNING: Invalid filter: missing ) after argument list", 'doc')
    'OK'.click()
  'Add Filter'.click()
    'Filter Name'.enter('Tees')
    'Add Line'.click()
      'Field Name'.enter('uniqueName')
      'operator'.enter('contains')
      'expression'.enter('Tee')
      'OK'.click()
    'OK'.click()
  'mainTable.1.Edit Product'.click()
    'Product Name'.shouldEqual('Long Sleeve Tee')
    'Back'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Add Line'.click()
      'Product'.enter('Hoodie with Logo (HL01)')
      'Quantity'.enter('15')
      'OK'.click()
    'Add Line'.click()
      'Product'.enter('Polo (P01)')
      'Quantity'.enter('1')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_reports'.click()
  'mainTable./Purchase Orders/.Run'.click()
  'mainTable'.shouldHaveCount(2)
  'Add Filter'.click()
    'Filter Name'.enter('Qty >= 15')
    'Add Line'.click()
      'Field Name'.enter('quantity')
      'operator'.enter('greater than or equal to')
      'expression'.enter('15')
      'OK'.click()
    'OK'.click()
  'mainTable'.shouldHaveCount(1)
  'mainTable.0.Product'.shouldEqual('Hoodie with Logo (HL01)')
  'Add Filter'.click()
    'Filter Name'.enter('Qty <= 2')
    'Add Line'.click()
      'Field Name'.enter('quantity')
      'operator'.enter('less than or equal to')
      'expression'.enter('2')
      'OK'.click()
    'OK'.click()
  'mainTable'.shouldHaveCount(1)
  'mainTable.0.Product'.shouldEqual('Polo (P01)')
  'Back'.click()
'stocktend_inventory'.click()
  'mainTable./Hoodie (H01)/.Adjust Qty'.click()
    'Quantity'.enter('1')
    'OK'.click()
  'mainTable./Hoodie with Zipper (#206600)/.Adjust Qty'.click()
    'Quantity'.enter('1')
    'OK'.click()
  'mainTable./Polo (P01)/.Adjust Qty'.click()
    'Quantity'.enter('1')
    'OK'.click()
  'Filter'.click()
  'Add Filter'.click()
    'Add Filter'.shouldBeCurrentPage()
    'Filter Name'.enter('Hoodies with stock') // ((qoh > 0) or (qoo >= 15)) and not (name contains Zipper) and (sku starts with H)
    'Add Line'.click()
      'Sequence'.shouldEqual('10')
      'Operator'.shouldEqual('equals')
      'Operator'.clickDropdown()
      'Operator'.shouldHaveOption('equals')
      'Operator'.shouldHaveOption('less than or equal to')
      'Operator'.enter('(')
      'Field Name'.shouldntExist()
      'Expression'.shouldntExist()
      'Add another line'.click()
      'Sequence'.shouldEqual('20')
      'Operator'.enter('greater than')
      'Field Name'.clickDropdown()
      'Field Name'.shouldHaveOption('quantityOnHand')
      'Field Name'.shouldHaveOption('quantityOnPurchaseOrders')
      'Field Name'.enter('quantityOnHandX')
      'Add another line'.click()
      'stFormRejection'.shouldContain("Invalid Field Name: quantityOnHandX")
      'Field Name'.enter('quantityOnHand')
      'Expression'.enter('0')
      'OK'.click()
    'OK'.click()
    'stFormRejection'.shouldContain("Invalid filter - expected closing bracket")
    'Add Line'.click()
      'Operator'.enter(')')
      'Sequence'.shouldEqual('30')
      'Add another line'.click()
      'Sequence'.shouldEqual('40')
      'Sequence'.enter('5')
      'Operator'.enter('(')
      'Add another line'.click()
      'Operator'.enter('or')
      'Add another line'.click()
      'Operator'.enter('(')
      'Add another line'.click()
      'Field Name'.enter('quantityOnPurchaseOrders')
      'Operator'.enter('greater than or equal to')
      'Expression'.enter('15')
      'OK'.click()
    'lines./quantityOnPurchaseOrders/.Operator'.shouldEqual('greater than or equal to')
    'Add Line'.click()
      'Operator'.enter(')')
      'Add another line'.click()
      'Operator'.enter(')')
      'Add another line'.click()
      'Operator'.enter('and')
      'Add another line'.click()
      'Operator'.enter('(')
      'Add another line'.click()
      'Operator'.enter('not')
      'Add another line'.click()
      'Field Name'.enter('uniqueName')
      'Operator'.enter('contains')
      'Expression'.enter('Zipper')
      'Add another line'.click()
      'Operator'.enter(')')
      'Add another line'.click()
      'Operator'.enter('and')
      'Add another line'.click()
      'Field Name'.enter('_sku')
      'Operator'.enter('starts with')
      'Expression'.enter('H')
      'Add another line'.click()
      'Operator'.enter('and')
      'Add another line'.click()
      'Operator'.enter('(')
      'Add another line'.click()
      'Operator'.enter('not')
      'Add another line'.click()
      'Field Name'.enter('_sku')
      'Operator'.enter('starts with')
      'Expression'.enter('HA')
      'Add another line'.click()
      'Operator'.enter(')')
      'OK'.click()
    'OK'.click()
  'Hoodies with stock'.shouldExist()
  'mainTable'.shouldHaveCount(3) // counting total
  'mainTable.1.SKU'.shouldEqual('H01')
  'mainTable.2.SKU'.shouldEqual('HL01')
  'mainTable./Cap (C01)/.SKU'.shouldntExist()
  'Hoodies with stock'.click()
  'Unfilter'.click()
  'mainTable./Cap (C01)/.SKU'.shouldExist()
  'Filter'.click()
  'Hoodies with stock'.click()
  'mainTable'.shouldHaveCount(3) // counting total
  'mainTable.1.Edit Product'.click()
    'Back'.click()
  'mainTable'.shouldHaveCount(3) // counting total
  'Tees'.click()
  'mainTable'.shouldHaveCount(2) // counting total
  'mainTable.1.Edit Product'.click()
    'Product Name'.shouldEqual('Long Sleeve Tee')
    'Back'.click()
  'Hoodies with stock'.click()
  'mainTable'.shouldHaveCount(3) // counting total
  'Manage Filters'.click()
    'Filters'.shouldBeCurrentPage()
    'mainTable'.shouldHaveCount(3)
    'mainTable./Hoodies with stock/.Edit'.click()
      'Edit Filter'.shouldBeCurrentPage()
      'Filter Name'.shouldEqual('Hoodies with stock')
      'Lines.0.Trash'.click() // the following lines get rid of the quantityOnHand > 0 or on order >= 15 part
      'Lines.0.Really Trash?'.click()
      'Lines.0.Trash'.click()
      'Lines.0.Really Trash?'.click()
      'Lines.0.Trash'.click()
      'Lines.0.Really Trash?'.click()
      'Lines.0.Trash'.click()
      'Lines.0.Really Trash?'.click()
      'Lines.0.Trash'.click()
      'Lines.0.Really Trash?'.click()
      'Lines.0.Trash'.click()
      'Lines.0.Really Trash?'.click()
      'Lines.0.Trash'.click()
      'Lines.0.Really Trash?'.click()
      'Lines.0.Trash'.click()
      'Lines.0.Really Trash?'.click()
      'Lines.0.Trash'.click()
      'Lines.0.Really Trash?'.click()
      'Lines.0.Trash'.click()
      'Lines.0.Really Trash?'.click()
      'OK'.click()
    'Back'.click()
  'mainTable'.shouldHaveCount(4) // counting total
  'mainTable./Cap (C01)/.SKU'.shouldntExist()
  'Hoodies with stock'.shouldExist()
  'Filter'.shouldntExist()
  'Manage Filters'.click()
    'mainTable./Hoodies with stock/.Trash'.click()
    'mainTable./Hoodies with stock/.Really Trash?'.click()
    'Back'.click()
  'Hoodies with stock'.shouldntExist()
  'Filter'.shouldExist()
  'mainTable./Cap (C01)/.SKU'.shouldExist()
  'Back'.click()
'stocktend_home'.click()
'helper'.trashAll('Supplier')
'helper'.trashAll('Inventory')
'helper'.trashAll('Template')
'helper'.trashAll('Facet')
'helper'.trashAll('Inventory')
'helper'.clearWCStockLevels()
'stocktend_suppliers'.click()
  'Add'.click()
    'Name'.enter('John')
    'OK'.click()
  'mainTable'.shouldHaveCount(1)
  'Back'.click()
'helper'.trashSupplierWithDifferentForeman('John')
'stocktend_suppliers'.click()
  'mainTable'.shouldHaveCount(1)
  'Refresh'.click()
  'mainTable'.shouldHaveCount(0)
  'Back'.click()
'helper'.untrashProduct('Polo', 'P01')
'stocktend_inventory'.click()
  'searcher'.enter('Polo')
  'mainTable'.shouldHaveCount(2) // Including total
  'mainTable.1.Product'.shouldEqual('Polo (P01)')
  'Back'.click()
'helper'.trashProductWithDifferentForeman('Polo (P01)')
'stocktend_inventory'.click()
  'searcher'.enter('Polo')
  'mainTable'.shouldHaveCount(0)
  'Back'.click()
'helper'.untrashProduct('Polo', 'P01')
'stocktend_inventory'.click()
  'searcher'.enter('Polo')
  'mainTable'.shouldHaveCount(2) // Including total
  'Back'.click()
'helper'.clearWCOrders()
'helper'.addWCOrder({product: 'Polo (P01)', quantity: 1, orderDate: global.todayLocal(), status: 'wc-completed'})
'helper'.trashAll('Template')
'helper'.trashAll('Facet')
'helper'.trashAll('Transaction')
'Inventory'.click()
  'Customize'.click()
    'Add Field'.click()
      'Get Value From'.enter('Inventory.totalSalesUnits')
      'Caption'.enter('Total Sales')
      'Display As'.enter('Number')
      'Minimum Decimals'.enter(0)
      'Maximum Decimals'.enter(0)
      'OK'.click()
    'OK'.click()
  'searcher'.enter('Polo')
  'mainTable./Polo (P01)/.Quantity On Hand'.shouldEqual('-1')
  'mainTable./Polo (P01)/.Total Sales'.shouldEqual('1')
  'Back'.click()
'helper'.trashOrderItemWithDifferentForeman('Polo (P01)')
'Inventory'.click()
  'searcher'.enter('Polo')
  'mainTable./Polo (P01)/.Quantity On Hand'.shouldEqual('0')
  'mainTable./Polo (P01)/.Total Sales'.shouldEqual('0')
  'Back'.click()
'helper'.addWCOrder({product: 'Polo (P01)', quantity: 1, orderDate: global.todayLocal(), status: 'wc-completed'})
'Inventory'.click()
  'searcher'.enter('Polo')
  'mainTable./Polo (P01)/.Quantity On Hand'.shouldEqual('-1')
  'mainTable./Polo (P01)/.Total Sales'.shouldEqual('1')
  'Back'.click()
'helper'.trashOrderWithDifferentForeman('Polo (P01)')
'Inventory'.click()
  'searcher'.enter('Polo')
  'mainTable./Polo (P01)/.Quantity On Hand'.shouldEqual('0')
  'mainTable./Polo (P01)/.Total Sales'.shouldEqual('0')
  'Back'.click()
'helper'.clearWCStockLevels()
'helper'.trashAll('Inventory')
'helper'.clearWCOrders()
'helper'.addWCOrder({product: 'Hoodie (H01)', quantity: 1, orderDate: global.todayLocal(), status: 'wc-completed'})
'Inventory'.click()
  'mainTable./Hoodie (H01)/.Quantity On Hand'.shouldEqual('-1')
  'Back'.click()
'helper'.trashAll('Inventory')
'helper'.trashAll('Cluster')
'helper'.trashAll('NextNumber')
'helper'.trashAll('Transaction')
'helper'.trashAll('Adjustment')
'helper'.trashAll('Facet')
'helper'.trashAll('Template')
'helper'.trashAll('Configuration')
'helper'.trashAll('PO')
'helper'.trashAll('POReceipt')
'helper'.trashAll('Supplier')
'helper'.setProductSkuWithDifferentForeman('Long Sleeve Tee', 'LST1')
'helper'.simulateBrowserRefresh()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Add Line'.click()
      'Product'.enter('Long Sleeve Tee (LST1)')
      'helper'.setProductSkuWithDifferentForeman('Long Sleeve Tee', 'LST2')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_inventory'.click()
  'searcher'.enter('Long Sleeve')
  'mainTable.1.On Purchase Orders'.shouldEqual('1')
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'mainTable.0.Trash'.click()
  'mainTable.0.Really Trash?'.click()
  'Back'.click()
'helper'.simulateBrowserRefresh()
'stocktend_inventory'.click()
  'searcher'.enter('Long Sleeve')
  'mainTable.1.On Purchase Orders'.shouldEqual('0')
  'mainTable.1.Edit Product'.click()
    'SKU'.enter('LST')
    'OK'.click()
  'mainTable.1.SKU'.shouldEqual('LST')
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Add Line'.click()
      'Product'.enter('Long Sleeve Tee (LST)')
      'Quantity'.enter('1')
      'Unit Price (Inc Tax)'.enter('45.00')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_inventory'.click()
  'searcher'.enter('Long Sleeve')
  'mainTable.1.On Purchase Orders'.shouldEqual('1')
  'mainTable.1.Edit Product'.click()
    'SKU'.enter('LSTA')
    'OK'.click()
  'mainTable.1.Edit Product'.click()
    'SKU'.shouldEqual('LSTA')
    'OK'.click()
  'mainTable.1.On Purchase Orders'.shouldEqual('1')
  'searcher'.enter('')
  'Back'.click()
'stocktend_inventory'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'mainTable.0.Edit'.click()
    'Lines.0.Description'.shouldEqual('Long Sleeve Tee (LSTA)')
    'Back'.click()
  'Back'.click()
'helper'.clearWCStockLevels()
'helper'.trashAll('Inventory')
'helper'.trashAll('Cluster')
'helper'.trashAll('NextNumber')
'helper'.trashAll('Transaction')
'helper'.trashAll('Adjustment')
'helper'.trashAll('Facet')
'helper'.trashAll('Template')
'helper'.trashAll('Configuration')
'helper'.trashAll('PO')
'helper'.trashAll('POReceipt')
'helper'.trashAll('Supplier')
'helper'.simulateBrowserRefresh()
'stocktend_suppliers'.click()
  'Add'.click()
    'Name'.enter('John')
    'Add another'.click()
    'Name'.enter('Mary')
    'OK'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Supplier'.enter('John')
    'Add Line'.click()
      'Product'.enter('Cap (C01)')
      'Quantity'.enter('-1')
      'Unit Price (Inc Tax)'.enter('90.00')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_inventory'.click()
  'mainTable./Cap (C01)/.On Purchase Orders'.shouldEqual('-1')
'stocktend_receivePurchases'.click()
  'mainTable./PO00001/.Enter Receipt'.click()
    'Lines.0.Ordered'.shouldEqual('-1')
    'Lines.0.Received'.shouldEqual('-1')
    'OK'.click()
  'mainTable'.shouldBeEmpty()
'stocktend_inventory'.click()
  'mainTable./Cap (C01)/.On Purchase Orders'.shouldEqual('0')
  'Back'.click()
'helper'.clearWCStockLevels()
'helper'.trashAll('Inventory')
'helper'.trashAll('Cluster')
'helper'.trashAll('Transaction')
'helper'.trashAll('Adjustment')
'helper'.trashAll('Facet')
'helper'.trashAll('Template')
'helper'.trashAll('Configuration')
'helper'.trashAll('PO')
'helper'.trashAll('POReceipt')
'helper'.trashAll('Supplier')
'stocktend_suppliers'.click()
  'Add'.click()
    'Name'.enter('John')
    'Add another'.click()
    'Name'.enter('Mary')
    'OK'.click()
  'Back'.click()
'stocktend_inventory'.click()
  'mainTable./Cap (C01)/.Edit Product'.click()
    'WooCommerce Regular Price'.enter('320.00')
    'OK'.click()
  'mainTable./Cap (C01)/.Adjust Qty'.click()
    'Quantity'.enter('5')
    'Unit Price (Inc Tax)'.enter('90.00')
    'OK'.click()
  'mainTable./Hoodie (H01)/.Adjust Qty'.click()
    'Quantity'.enter('6')
    'Unit Price (Inc Tax)'.enter('100.00')
    'OK'.click()
  'mainTable./Polo (P01)/.Adjust Qty'.click()
    'Quantity'.enter('12')
    'Unit Price (Inc Tax)'.enter('110.00')
    'OK'.click()
  'stocktend_settings'.click()
    'Utilities'.click()
      'Export'.click()
        'Download to Excel'.click()
          'messageDialogText'.shouldEqual("Please select a data type", 'doc')
          'messageDialogOK'.click('doc')
        'Data Type'.enter('Inventory')
        'Download to Excel'.click() // NOTE: sets global.exportedJsonData as well
        'Back'.click()
      'helper'.alterExportedJsonData({row: 2, fieldName: 'quantityOnHand', value: 10}) // Cap
      'helper'.alterExportedJsonData({row: 2, fieldName: 'inventoryValue', value: 900})
      'helper'.alterExportedJsonData({row: 2, fieldName: 'inventoryValue2', value: 900})
      'helper'.alterExportedJsonData({row: 2, fieldName: 'inventoryValueExclConsignment', value: 900})
      'helper'.alterExportedJsonData({row: 2, fieldName: 'inventoryValueExclTax', value: 900})
      'helper'.alterExportedJsonData({row: 2, fieldName: 'inventoryValueExclConsignmentExclTax', value: 900})
      'helper'.alterExportedJsonData({row: 2, fieldName: 'inventoryValueRetail', value: 3200})
      'helper'.alterExportedJsonData({row: 3, fieldName: 'avgUnitCost', value: 143.2678}) // Hoodie
      'helper'.alterExportedJsonData({row: 3, fieldName: 'avgUnitCostExclTax', value: 143.2678}) // Hoodie
      'helper'.alterExportedJsonData({row: 3, fieldName: 'inventoryValue', value: 859.61})
      'helper'.alterExportedJsonData({row: 3, fieldName: 'inventoryValue2', value: 859.61})
      'helper'.alterExportedJsonData({row: 3, fieldName: 'inventoryValueExclConsignment', value: 859.61})
      'helper'.alterExportedJsonData({row: 3, fieldName: 'inventoryValueExclTax', value: 859.61})
      'helper'.alterExportedJsonData({row: 3, fieldName: 'inventoryValueExclConsignmentExclTax', value: 859.61})
      'helper'.alterExportedJsonData({row: 3, fieldName: 'marginPct', value: -218.37})
      'helper'.addToExportedJsonData({product: 'Hoodie with Logo (HL01)', quantityOnHand: 20})
      'helper'.addToExportedJsonData({product: 'Hoodie with Pocket (HP01)', quantityOnHand: "30"})
      'Import'.click()
        'Start Importing'.click()
          'messageDialogText'.shouldEqual("Please select a file", 'doc')
          'messageDialogOK'.click('doc')
        'Excel File to Import From'.useExportedJsonData()
        'Start Importing'.click()
          'messageDialogText'.shouldEqual("Inventory: creating: 2, updating: 2, unchanged: 1. Do you want to save these changes?", 'doc')
          'messageDialogNo'.click('doc')
        'stocktend_inventory'.click()
          'mainTable./Cap (C01)/.Quantity on Hand'.shouldEqual('5')
          'mainTable./Hoodie with Logo (HL01)/.Quantity on Hand'.shouldEqual('0')
          'mainTable./Hoodie with Pocket (HP01)/.Quantity on Hand'.shouldEqual('0')
          'Back'.click()
        'Excel File to Import From'.useExportedJsonData()
        'Start Importing'.click()
          'messageDialogText'.shouldEqual("Inventory: creating: 2, updating: 2, unchanged: 1. Do you want to save these changes?", 'doc')
          'messageDialogYes'.click('doc')
          'messageDialogText'.shouldEqual("Changes were saved successfully", 'doc')
          'messageDialogOK'.click('doc')
        'stocktend_inventory'.click()
          'mainTable./Cap (C01)/.Quantity on Hand'.shouldEqual('10')
          'mainTable./Hoodie (H01)/.Avg Unit Cost'.shouldEqual('143.2678')
          'mainTable./Hoodie with Logo (HL01)/.Quantity on Hand'.shouldEqual('20')
          'mainTable./Hoodie with Pocket (HP01)/.Quantity on Hand'.shouldEqual('30')
          'Back'.click()
        'Back'.click()
      'Back'.click()
    'Back'.click()
  'mainTable./Cap (C01)/.Edit Product'.click()
    'Avg Unit Cost'.shouldEqual('90.00')
    'Avg Unit Cost'.shouldBeReadOnly()
    'WooCommerce Regular Price'.enter('279.00')
    'Margin %'.shouldEqual('67.74')
    'Margin %'.shouldBeReadOnly()
    'Add Supplier'.click()
      'Supplier'.enter('John')
      'Recommended Retail Price (inc Tax)'.enter('299.95')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'helper'.simulateBrowserRefresh()
'helper'.flushCache()
'stocktend_inventory'.click()
  'mainTable./Cap (C01)/.Edit Product'.click()
    'WooCommerce Regular Price'.shouldEqual('279.00')
    'Avg Unit Cost'.shouldEqual('90.00')
    'WooCommerce Regular Price'.enter('280.00')
    'Margin %'.shouldEqual('67.86')
    'OK'.click()
  'mainTable./Cap (C01)/.Edit Product'.click()
    'WooCommerce Regular Price'.shouldEqual('280.00')
    'Back'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00001')
    'Supplier'.enter('John')
    'Order Date'.enter('31/07/2020')
    'Add Line'.click()
      'Product'.enter('Cap (C01)')
      'Quantity'.enter('2')
      'Unit Price (Inc Tax)'.enter('100.00')
      'Tax %'.enter('20')
      'Avg Unit Cost (including this Order)'.shouldBeReadOnly()
      'Avg Unit Cost (including this Order)'.shouldEqual('92.86')
      'Recommended Retail Price (inc Tax)'.shouldEqual('299.95')
      'WooCommerce Regular Price'.shouldEqual('280.00')
      'Margin %'.shouldBeReadOnly()
      'Margin %'.shouldEqual('68.54')
      'Recommended Retail Price (inc Tax)'.enter('350.00')
      'Margin %'.shouldEqual('68.54')
      'WooCommerce Regular Price'.enter('300.00')
      'Margin %'.shouldEqual('70.63')
      'OK'.click()
    'Lines.0.Edit'.click()
      'Recommended Retail Price (inc Tax)'.shouldEqual('350.00')
      'WooCommerce Regular Price'.shouldEqual('300.00')
      'Margin %'.shouldEqual('70.63')
      'WooCommerce Regular Price'.enter('310.00')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_inventory'.click()
  'mainTable./Cap (C01)/.Edit Product'.click()
    'WooCommerce Regular Price'.shouldEqual('310.00')
    'Suppliers.0.Edit'.click()
      'Recommended Retail Price (inc Tax)'.shouldEqual('350.00')
      'Back'.click()
    'Back'.click()
  'Back'.click()
'helper'.simulateBrowserRefresh()
'helper'.flushCache()
'stocktend_inventory'.click()
  'mainTable./Cap (C01)/.Edit Product'.click()
    'WooCommerce Regular Price'.shouldEqual('310.00')
    'Suppliers.0.Edit'.click()
      'Recommended Retail Price (inc Tax)'.shouldEqual('350.00')
      'Back'.click()
    'OK'.click()
  'Back'.click()
'stocktend_receivePurchases'.click()
  'mainTable./PO00001/.Enter Receipt'.click()
    'Lines.0.Edit'.click()
      'lots'.shouldntExist()
      'Received'.enter('1')
      'Unit Price (Inc Tax)'.shouldEqual('100.00')
      'Avg Unit Cost (including this Order)'.shouldBeReadOnly()
      'Avg Unit Cost (including this Order)'.shouldEqual('92.86')
      'Unit Price (Inc Tax)'.enter('95.00')
      'Avg Unit Cost (including this Order)'.shouldEqual('91.43')
      'Recommended Retail Price (inc Tax)'.shouldEqual('350.00')
      'WooCommerce Regular Price'.shouldEqual('310.00')
      'Margin %'.shouldBeReadOnly()
      'Margin %'.shouldEqual('71.97')
      'Recommended Retail Price (inc Tax)'.enter('360.00')
      'WooCommerce Regular Price'.enter('320.00')
      'Margin %'.shouldEqual('72.84')
      'OK'.click()
    'Lines.0.Edit'.click()
      'Unit Price (Inc Tax)'.shouldEqual('95.00')
      'Avg Unit Cost (including this Order)'.shouldEqual('91.43')
      'Recommended Retail Price (inc Tax)'.shouldEqual('360.00')
      'WooCommerce Regular Price'.shouldEqual('320.00')
      'OK'.click()
    'Delivery Note'.click()
    'OK'.click()
  'Back'.click()
'stocktend_inventory'.click()
  'mainTable./Cap (C01)/.Edit Product'.click()
    'WooCommerce Regular Price'.shouldEqual('320.00')
    'Suppliers.0.Edit'.click()
      'Recommended Retail Price (inc Tax)'.shouldEqual('360.00')
      'Back'.click()
    'OK'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'mainTable./PO00001/.Edit'.click()
    'Lines.0.Edit'.click()
      'Unit Price (Inc Tax)'.shouldEqual('95.00')
      'Avg Unit Cost (including this Order)'.shouldEqual('91.43')
      'Recommended Retail Price (inc Tax)'.shouldEqual('360.00')
      'WooCommerce Regular Price'.shouldEqual('320.00')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'helper'.clearWCStockLevels()
'helper'.trashAll('Inventory')
'helper'.trashAll('Transaction')
'helper'.trashAll('Facet')
'helper'.trashAll('Template')
'helper'.trashAll('Configuration')
'helper'.trashAll('PO')
'helper'.trashAll('POReceipt')
'helper'.trashAll('Supplier')
'stocktend_settings'.click()
  'Default Tax %'.enter('20.00')
  'OK'.click()
'stocktend_suppliers'.click()
  'Add'.click()
    'Name'.enter('John')
    'Tax %'.shouldEqual('20.00')
    'Add another'.click()
    'Name'.enter('Mary')
    'OK'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00001')
    'Supplier'.enter('John')
    'Order Date'.enter('31/07/2020')
    'Add Line'.click()
      'Product'.enter('Cap (C01)')
      'Quantity'.enter('2')
      'Unit Price (Inc Tax)'.enter('100.00')
      'Tax %'.enter('20')
      'OK'.click()
    'OK'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00002')
    'Supplier'.enter('John')
    'Order Date'.enter('01/08/2020')
    'Add Line'.click()
      'Product'.enter('Cap (C01)') // Standard (can't claim input VAT)
      'Quantity'.enter('3')
      'Unit Price (Inc Tax)'.enter('100.00')
      'Tax %'.shouldEqual('20.00')
      'OK'.click()
    'Add Line'.click()
      'Product'.enter('Hoodie (H01)') // Exempt (can claim input VAT)
      'Quantity'.enter('4')
      'Unit Price (Inc Tax)'.enter('200.00')
      'Tax %'.shouldEqual('20.00')
      'OK'.click()
    'Add Line'.click()
      'Product'.enter('Hoodie with Logo (HL01)') // Zero rated
      'Quantity'.enter('5')
      'Unit Price (Inc Tax)'.enter('300.00')
      'Tax %'.shouldEqual('0.00')
      'OK'.click()
    'Add Line'.click()
      'Line Type'.enter('Shipping')
      'Unit Price (Inc Tax)'.enter('50.00')
      'Tax %'.enter('15')
      'OK'.click()
    'Add Line'.click()
      'Line Type'.enter('Fee')
      'Unit Price (Inc Tax)'.enter('20.00')
      'Tax %'.enter('10')
      'OK'.click()
    'Add Line'.click()
      'Line Type'.enter('Other')
      'Description'.enter('Special charge')
      'Unit Price (Inc Tax)'.enter('10.00')
      'Tax %'.enter('5')
      'OK'.click()
    'OK'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00003')
    'Supplier'.enter('Mary')
    'Order Date'.enter('07/08/2020')
    'Add Line'.click()
      'Product'.enter('Cap (C01)')
      'Quantity'.enter('6')
      'Unit Price (Inc Tax)'.enter('110.00')
      'Tax %'.shouldEqual('20.00')
      'OK'.click()
    'Add Line'.click()
      'Line Type'.enter('Shipping')
      'Unit Price (Inc Tax)'.enter('60.00')
      'Tax %'.enter('15')
      'OK'.click()
    'OK'.click()
  'stocktend_settings'.click()
    'Utilities'.click()
      'Export'.click()
        'Download to Excel'.click()
          'messageDialogText'.shouldEqual("Please select a data type", 'doc')
          'messageDialogOK'.click('doc')
        'Data Type'.enter('Cluster')
        'Download to Excel'.click()
        'Data Type'.enter('PO')
        'Download to Excel'.click()
        'Back'.click()
      'Import'.click()
        'helper'.alterExportedJsonData({row: 2, fieldName: '$RowType', value: "xxx"})
        'Excel File to Import From'.useExportedJsonData()
        'Start Importing'.click()
          'messageDialogText'.shouldEqual("Row 2: Invalid row type: xxx (No data was imported)", 'doc')
          'messageDialogOK'.click('doc')
        'helper'.alterExportedJsonData({row: 2, fieldName: '$RowType', value: "Header"})
        'helper'.alterExportedJsonData({row: 2, fieldName: 'orderDate', value: "Header"})
        'Excel File to Import From'.useExportedJsonData()
        'Start Importing'.click()
          'messageDialogText'.shouldEqual('Row 2: Please enter Order Date (No data was imported)', 'doc')
          'messageDialogOK'.click('doc')
        'helper'.alterExportedJsonData({row: 2, fieldName: 'orderDate', value: "30/7/2020"}) // PO00001
        'helper'.alterExportedJsonData({row: 4, fieldName: 'supplier', value: "Mary"}) // PO00002
        'helper'.alterExportedJsonData({row: 5, fieldName: 'LineItem.unitCostIncTaxFX', value: 110}) // PO00002
        'helper'.alterExportedJsonData({row: 5, fieldName: 'LineItem.unitCostExclTax', value: 91.666667}) // PO00002
        'helper'.alterExportedJsonData({row: 5, fieldName: 'LineItem.lineCostIncTax', value: 330}) // PO00002
        'helper'.alterExportedJsonData({row: 5, fieldName: 'LineItem.lineCostExclTax', value: 275}) // PO00002
        'helper'.alterExportedJsonData({row: 5, fieldName: 'LineItem.lineCostIncTaxFX', value: 330}) // PO00002
        'helper'.alterExportedJsonData({row: 5, fieldName: 'LineItem.lineCostExclTaxFX', value: 275}) // PO00002
        'helper'.alterExportedJsonData({row: 5, fieldName: 'LineItem.lineTax', value: 55}) // PO00002
        'helper'.alterExportedJsonData({row: 5, fieldName: 'LineItem.lineTaxFX', value: 55}) // PO00002
        'helper'.alterExportedJsonData({row: 5, fieldName: 'LineItem.avgUnitCostIncludingThisOrder', value: 110}) // PO00002
        'helper'.alterExportedJsonData({row: 5, fieldName: 'LineItem.avgUnitCostIncThisOrderExTax', value: 91.67}) // PO00002
        'helper'.alterExportedJsonData({row: 5, fieldName: 'LineItem.marginPct', value: 71.35}) // PO00002
        'helper'.alterExportedJsonData({row: 5, fieldName: 'LineItem.unitCostIncTaxFXRounded', value: 110}) // PO00002
        'helper'.addToExportedJsonData({$RowType: 'Header', purchaseOrderNumber: 'PO00004', supplier: 'John', orderDate: '14/08/2020', expectedDeliveryDate: '14/08/2020'})
        'helper'.addToExportedJsonData({$RowType: 'LineItem', 'LineItem.purchaseOrder': 'PO00004', 'LineItem.product': 'Hoodie (H01)', 'LineItem.quantity': 1, 'LineItem.unitCostIncTaxFX': '200.00', 'LineItem.taxPct': 20})
        'helper'.addToExportedJsonData({$RowType: 'LineItem', 'LineItem.purchaseOrder': 'PO00004', 'LineItem.lineType': 'Fee', 'LineItem.unitCostIncTaxFX': '10.00', 'LineItem.taxPct': 10})
        'helper'.addToExportedJsonData({$RowType: 'Header', purchaseOrderNumber: 'PO00005', orderDate: '14/08/2020', expectedDeliveryDate: '14/08/2020'})
        'helper'.addToExportedJsonData({$RowType: 'LineItem', 'LineItem.purchaseOrder': 'PO00005', 'LineItem.product': 'Hoodie (H01)', 'LineItem.quantity': 7, 'LineItem.unitCostIncTaxFX': '20.00'})
        'Excel File to Import From'.useExportedJsonData()
        'Start Importing'.click()
          'messageDialogText'.shouldEqual("PO: creating: 2, updating: 2, unchanged: 1. Do you want to save these changes?", 'doc')
          'messageDialogYes'.click('doc')
          'messageDialogText'.shouldEqual("Changes were saved successfully", 'doc')
          'messageDialogOK'.click('doc')
        'Back'.click()
      'Back'.click()
    'Back'.click()
  'mainTable./PO00001/.Edit'.click()
    'Order Date'.shouldEqual('30/07/2020')
    'Order Date'.enter('31/07/2020')
    'OK'.click()
  'mainTable./PO00002/.Edit'.click()
    'Supplier'.shouldEqual('Mary')
    'Supplier'.enter('John')
    'OK'.click()
  'mainTable./PO00005/.Trash'.click()
  'mainTable./PO00005/.Really Trash?'.click() // 'Add'.click() 'Purchase Order Number'.enter('PO00004') 'Supplier'.enter('John') 'Order Date'.enter('14/08/2020') 'Add Line'.click() 'Product'.enter('Hoodie (H01)') 'Quantity'.enter('1') 'Unit Price (Inc Tax)'.enter('200.00') 'Tax %'.shouldEqual('20.00') 'OK'.click() 'Add Line'.click() 'Line Type'.enter('Fee') 'Unit Price (Inc Tax)'.enter('10.00') 'Tax %'.enter('10') 'OK'.click() 'OK'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00005')
    'Supplier'.enter('Mary')
    'Order Date'.enter('31/08/2020')
    'Add Line'.click()
      'Product'.enter('Hoodie with Logo (HL01)') // Zero rated
      'Quantity'.enter('6')
      'Unit Price (Inc Tax)'.enter('300.00')
      'Tax %'.shouldEqual('0.00')
      'OK'.click()
    'Add Line'.click()
      'Line Type'.enter('Other')
      'Description'.enter('Special charge')
      'Unit Price (Inc Tax)'.enter('10.00')
      'Tax %'.enter('5')
      'OK'.click()
    'OK'.click()
  'mainTable./PO00002/.Edit'.click()
    'View Receipts'.shouldntExist()
    'Lines.0.Edit'.click()
      'Unit Price (Inc Tax)'.enter('100.00')
      'OK'.click()
    'Back'.click()
  'Back'.click()
'Receive Purchases'.click()
  'mainTable./PO00001/.Enter Receipt'.click()
    'Received Date'.enter('31/07/2020')
    'OK'.click()
  'mainTable./PO00002/.Enter Receipt'.click()
    'Received Date'.enter('07/08/2020')
    'OK'.click()
  'mainTable./PO00003/.Enter Receipt'.click()
    'Received Date'.enter('14/08/2020')
    'OK'.click()
  'mainTable./PO00004/.Enter Receipt'.click()
    'Received Date'.enter('21/08/2020')
    'OK'.click()
  'mainTable./PO00005/.Enter Receipt'.click()
    'Received Date'.enter('31/08/2020')
    'Lines./Hoodie with Logo (HL01)/.Edit'.click()
      'Received'.enter('5')
      'Cancelled Quantity'.enter('1')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'mainTable./PO00002/.Edit'.click()
    'View Receipts'.click()
      'View Receipts for Purchase Order PO00002'.shouldBeCurrentPage()
      'mainTable'.shouldHaveCount(1)
      'mainTable.Receipt Number'.shouldEqual('PO00002-01')
      'Back'.click()
    'Back'.click()
  'Tax Report'.click()
  'From Date'.enter('01/08/2020')
  'To Date'.enter('31/08/2020')
  'Go'.click()
  'mainTable'.shouldHaveCount(6)
  'mainTable./exempt/.PO Line Type'.shouldEqual('Product')
  'mainTable./exempt/.Tax Class'.shouldEqual('exempt')
  'mainTable./exempt/.Tax %'.shouldEqual('20.00')
  'mainTable./exempt/.Purchase Value (inc Tax)'.shouldEqual('1,000.00')
  'mainTable./exempt/.Tax Amount'.shouldEqual('166.67')
  'mainTable./standard/.PO Line Type'.shouldEqual('Product')
  'mainTable./standard/.Tax Class'.shouldEqual('standard')
  'mainTable./standard/.Tax %'.shouldEqual('20.00')
  'mainTable./standard/.Purchase Value (inc Tax)'.shouldEqual('960.00')
  'mainTable./standard/.Tax Amount'.shouldEqual('160.00')
  'mainTable./zero-rated/.PO Line Type'.shouldEqual('Product')
  'mainTable./zero-rated/.Tax Class'.shouldEqual('zero-rated')
  'mainTable./zero-rated/.Tax %'.shouldEqual('0.00')
  'mainTable./zero-rated/.Purchase Value (inc Tax)'.shouldEqual('3,000.00')
  'mainTable./zero-rated/.Tax Amount'.shouldEqual('0.00')
  'mainTable./Shipping/.PO Line Type'.shouldEqual('Shipping')
  'mainTable./Shipping/.Tax Class'.shouldEqual('')
  'mainTable./Shipping/.Tax %'.shouldEqual('15.00')
  'mainTable./Shipping/.Purchase Value (inc Tax)'.shouldEqual('110.00')
  'mainTable./Shipping/.Tax Amount'.shouldEqual('14.35')
  'mainTable./Fee/.PO Line Type'.shouldEqual('Fee')
  'mainTable./Fee/.Tax Class'.shouldEqual('')
  'mainTable./Fee/.Tax %'.shouldEqual('10.00')
  'mainTable./Fee/.Purchase Value (inc Tax)'.shouldEqual('30.00')
  'mainTable./Fee/.Tax Amount'.shouldEqual('2.73')
  'mainTable./Other/.PO Line Type'.shouldEqual('Other')
  'mainTable./Other/.Tax Class'.shouldEqual('')
  'mainTable./Other/.Tax %'.shouldEqual('5.00')
  'mainTable./Other/.Purchase Value (inc Tax)'.shouldEqual('20.00')
  'mainTable./Other/.Tax Amount'.shouldEqual('0.95')
  'Back'.click()
'stocktend_reports'.click()
  'mainTable./Tax Report (Purchases)/.Run'.click()
  'Back'.click()
'helper'.trashAll('Cluster')
'helper'.trashAll('Inventory')
'helper'.trashAll('Transaction')
'helper'.trashAll('Facet')
'helper'.trashAll('Template')
'helper'.trashAll('Configuration')
'helper'.trashAll('Avenue')
'helper'.trashAll('PO')
'helper'.trashAll('Transfer')
'helper'.trashAll('Supplier')
'helper'.trashAll('Location')
'helper'.clearWCStockLevels()
'helper'.flushCache()
'helper'.simulateBrowserRefresh()
'helper'.setWCLowStockAmount('Cap (C01)', 6)
'Locations'.click()
'Add'.click()
'Name'.enter('WH01')
'Parent Location'.shouldEqual('General')
'OK'.click()
'stocktend_suppliers'.click()
'Add'.click()
'Name'.enter('Castaways')
'Save'.click()
'Add another'.click()
'Name'.enter('Bombast Corporation')
'Add another'.click()
'Name'.enter('Reignite')
'Save'.click()
'Back'.click()
'stocktend_purchaseOrders'.click()
'Add'.click()
'Supplier'.enter('Reignite')
'Add Line'.click()
'Product'.enter('Hoodie (H01)')
'OK'.click()
'OK'.click()
'Inventory'.click()
'mainTable./Hoodie (H01)/.Product'.click()
'Suppliers.0.Supplier Product Name'.shouldEqual('Hoodie')
'Suppliers.0.Edit'.click()
'Supplier SKU'.enter('HOODIE-BASIC')
'OK'.click()
'OK'.click()
'Back'.click()
'stocktend_purchaseOrders'.click()
'Add'.click()
'Supplier'.enter('Reignite')
'Add Line'.click()
'Product'.enter('Hoodie (H01)')
'OK'.click()
'OK'.click()
'Inventory'.click()
'mainTable./Hoodie (H01)/.Product'.click()
'Low Stock Threshold'.enter('13')
'Suppliers'.shouldHaveCount(1)
'OK'.click()
'mainTable./Cap (C01)/.Product'.click()
'Edit Product'.shouldBeCurrentPage()
'Product Name'.shouldEqual('Cap')
'SKU'.shouldEqual('C01')
'Low Stock Threshold'.shouldEqual('6')
'Maximum Quantity to Replenish To'.shouldEqual('0')
'Low Stock Threshold'.enter('5')
'Maximum Quantity to Replenish To'.enter('20')
'Suppliers'.shouldHaveCount(0)
'Add Supplier'.click()
'Add Product Supplier'.shouldBeCurrentPage()
'OK'.click()
'stFormRejection'.shouldContain('Supplier is required')
'Supplier'.chooseOption('Castaways')
'Supplier Product Name'.shouldEqual('Cap')
'Supplier SKU'.shouldEqual('C01')
'Is Main Supplier of Product'.shouldEqual('Yes')
'OK'.click()
'Suppliers'.shouldHaveCount(1)
'Add Supplier'.click()
'Supplier'.chooseOption('Castaways')
'OK'.click()
'stFormRejection'.shouldContain('This supplier is already a supplier of this product')
'Supplier'.chooseOption('Bombast Corporation')
'Supplier Product Name'.shouldEqual('Cap')
'Supplier SKU'.shouldEqual('C01')
'Is Main Supplier of Product'.shouldEqual('No')
'Supplier Product Name'.enter('Basic Cap')
'Supplier SKU'.enter('CAP-BASIC')
'Is Main Supplier of Product'.chooseOption('Yes')
'Save'.click()
'Back'.click()
'Edit Product'.shouldBeCurrentPage()
'Suppliers'.shouldHaveCount(2)
'Suppliers./Castaways/.Main'.shouldEqual('No')
'Suppliers./Bombast Corporation/.Main'.shouldEqual('Yes')
'Suppliers./Bombast Corporation/.Supplier SKU'.shouldEqual('CAP-BASIC')
'Suppliers./Bombast Corporation/.Supplier Product Name'.shouldEqual('Basic Cap')
'OK'.click()
'helper'.flushCache()
'helper'.checkWCLowStockAmount('Cap (C01)', 5)
'mainTable./Cap (C01)/.Product'.click()
'Suppliers./Bombast Corporation/.Supplier Product Name'.shouldEqual('Basic Cap')
'Back'.click()
'stocktend_suppliers'.click()
'mainTable./Castaways/.Trash'.click()
'mainTable./Castaways/.Really Trash?'.click()
'messageDialogText'.shouldEqual("Supplier is referenced on Product Cap (C01) and so cannot be trashed", 'doc')
'messageDialogOK'.click('doc')
'Back'.click()
'Inventory'.click()
'mainTable./Cap (C01)/.Product'.click()
'Suppliers./Castaways/.Trash'.click()
'Suppliers./Castaways/.Really Trash?'.click()
'OK'.click()
'stocktend_suppliers'.click()
'mainTable'.shouldHaveCount(3)
'mainTable./Castaways/.Trash'.click()
'mainTable./Castaways/.Really Trash?'.click()
'messageDialogText'.shouldntExist()
'mainTable'.shouldHaveCount(2)
'Inventory'.click()
'searcher'.enter('s')
'mainTable./Shórts - Blue (SB01)/.Adjust Qty'.click()
  'Enter Inventory Adjustment'.shouldBeCurrentPage()
  'Product'.shouldEqual('Shórts - Blue (SB01)')
  'Quantity Change'.enter('5')
  'Location'.shouldEqual('General')
  'Location'.enter('WH01')
  'OK'.click()
'Inventory'.shouldBeCurrentPage()
'searcher'.enter('s')
'mainTable./Shórts - Blue (SB01)/.View History'.click()
  'Inventory History'.shouldBeCurrentPage()
  'Product'.shouldEqual('Shórts - Blue (SB01)')
  'Product'.shouldBeReadOnly()
  'mainTable.0.Date'.shouldEqualExpression('global.todayLocal().toLocalMMMDY()')
  'mainTable.0.Quantity'.shouldEqual('5')
  'mainTable.0.Balance'.shouldEqual('5')
  'mainTable.0.Source'.shouldEqual('Adjustment')
  'mainTable.0.Location'.shouldEqual('WH01')
  'Back'.click()
'Inventory'.shouldBeCurrentPage()
'searcher'.enter('s')
'mainTable./Shórts - Blue (SB01)/.Adjust Qty'.click()
  'Quantity Change'.enter('-1')
  'OK'.click()
'searcher'.enter('s')
'mainTable./Shórts - Blue (SB01)/.View History'.click()
  'mainTable.0.Quantity'.shouldEqual('-1')
  'mainTable.0.Balance'.shouldEqual('4')
  'mainTable.0.Location'.shouldEqual('General')
  'Back'.click()
'Location Inventory'.click()
  'Location'.shouldEqual('General')
  'searcher'.enter('s')
  'mainTable./Shórts - Blue (SB01)/.On Hand'.shouldEqual('-1')
  'mainTable./Shórts - Blue (SB01)/.View History'.click()
    'Location Inventory History'.shouldBeCurrentPage()
    'Product'.shouldEqual('Shórts - Blue (SB01)')
    'Product'.shouldBeReadOnly()
    'Location'.shouldEqual('General')
    'Location'.shouldBeReadOnly()
    'mainTable.0.Quantity'.shouldEqual('-1')
    'mainTable.0.Balance'.shouldEqual('-1')
    'Back'.click()
  'Location'.enter('WH01')
  'mainTable./Shórts - Blue (SB01)/.View History'.click()
    'Location'.shouldEqual('WH01')
    'mainTable.0.Quantity'.shouldEqual('5')
    'mainTable.0.Balance'.shouldEqual('5')
    'Back'.click()
  'Location'.enter('WH01')
  'mainTable./Shórts - Blue (SB01)/.On Hand'.shouldEqual('5')
  'mainTable./Shórts - Blue (SB01)/.Adjust Qty'.click()
    'Enter Inventory Adjustment'.shouldBeCurrentPage()
    'Location'.shouldEqual('WH01')
    'Product'.shouldEqual('Shórts - Blue (SB01)')
    'Quantity'.enter('1')
    'OK'.click()
  'Location'.enter('WH01')
  'mainTable./Shórts - Blue (SB01)/.On Hand'.shouldEqual('6')
  'mainTable./Shórts - Blue (SB01)/.Adjust Qty'.click()
    'Enter Inventory Adjustment'.shouldBeCurrentPage()
    'Location'.shouldEqual('WH01')
    'Quantity'.enter('-1')
    'OK'.click()
  'Back'.click()
'Inventory'.shouldBeCurrentPage()
'mainTable./Shórts - Blue (SB01)/.Inventory by Location'.click()
  'Product Inventory by Location'.shouldBeCurrentPage()
  'Product'.shouldEqual('Shórts - Blue (SB01)')
  'mainTable./General/.On Hand'.shouldEqual('-1')
  'mainTable./WH01/.On Hand'.shouldEqual('5')
  'Product'.enter('Hoodie (H01)')
  'mainTable./General/.On Hand'.shouldEqual('0')
  'Back'.click()
'Inventory'.shouldBeCurrentPage()
'mainTable./Shórts - Blue (SB01)/.Transfer Between Locations'.click()
  'Enter Inventory Transfer'.shouldBeCurrentPage()
  'Transfer Number'.shouldMatch('TF[0-9]*')
  'Transfer Number'.enter('TF00001')
  'Date'.shouldEqualExpression('global.todayLocal()')
  'Product'.shouldEqual('Shórts - Blue (SB01)')
  'From Location'.shouldEqual('General')
  'To Location'.shouldEqual('General')
  'Notes'.enter('Moved to quarantine area')
  'OK'.click()
  'stFormRejection'.shouldContain('Quantity to Transfer is required')
  'Quantity'.enter('2')
  'OK'.click()
  'stFormRejection'.shouldContain('The locations must be different')
  'From Location'.enter('WH01')
  'OK'.click()
'Inventory'.shouldBeCurrentPage()
'mainTable./Shórts - Blue (SB01)/.Inventory by Location'.click()
  'Product Inventory by Location'.shouldBeCurrentPage()
  'mainTable./General/.On Hand'.shouldEqual('1')
  'mainTable./WH01/.On Hand'.shouldEqual('3')
  'Back'.click()
'searcher'.enter('b')
'mainTable./Belt (#33)/.Transfer Between Locations'.click()
  'Quantity'.enter('1')
  'To Location'.enter('WH01')
  'OK'.click()
'searcher'.enter('s')
'mainTable./Shórts - Blue (SB01)/.Transfer Between Locations'.click()
  'Enter Inventory Transfer'.shouldBeCurrentPage()
  'Transfer Number'.enter('TF2')
  'Notes'.enter('Moved from quarantine area')
  'Quantity'.enter('1')
  'To Location'.enter('WH01')
  'OK'.click()
'mainTable./Shórts - Blue (SB01)/.Inventory by Location'.click()
  'Product Inventory by Location'.shouldBeCurrentPage()
  'mainTable./General/.On Hand'.shouldEqual('0')
  'mainTable./WH01/.On Hand'.shouldEqual('4')
  'Back'.click()
'Inventory'.shouldBeCurrentPage()
'mainTable./Shórts - Blue (SB01)/.View History'.click()
  'mainTable.0.Quantity'.shouldEqual('1')
  'mainTable.0.Location'.shouldEqual('WH01')
  'mainTable.0.Reference'.shouldEqual('TF2')
  'mainTable.1.Quantity'.shouldEqual('-1')
  'mainTable.1.Location'.shouldEqual('General')
  'mainTable.1.Reference'.shouldEqual('TF2')
  'mainTable.1.Reference'.click()
    'View Inventory Transfer'.shouldBeCurrentPage()
    'Product'.shouldEqual('Shórts - Blue (SB01)')
    'From Location'.shouldEqual('General')
    'To Location'.shouldEqual('WH01')
    'Quantity'.shouldEqual('1')
    'Back'.click()
  'Back'.click()
'helper'.trashAll('Cluster')
'helper'.trashAll('Inventory')
'helper'.trashAll('Transaction')
'helper'.trashAll('Avenue')
'helper'.trashAll('PO')
'helper'.trashAll('Supplier')
'stocktend_suppliers'.click()
'Add'.click()
'Name'.enter('Castaways')
'Delivery Lead Days'.enter('200')
'Save'.click()
'Add another'.click()
'Name'.enter('Bombast Corporation')
'Save'.click()
'helper'.trashAll('Inventory')
'helper'.trashAll('Transaction')
'helper'.trashAll('Facet')
'helper'.trashAll('Template')
'helper'.trashAll('Configuration')
'helper'.clearWCStockLevels()
'helper'.setWCLowStockAmount('Hoodie (H01)', 13)
'helper'.flushCache()
'helper'.simulateBrowserRefresh()
'Inventory'.click()
'searcher'.enter('s')
'mainTable./Shórts - Red (SR01)/.Quantity On Hand'.shouldEqual('0')
'mainTable./Shórts - Red (SR01)/.On Purchase Orders'.shouldEqual('0')
'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('0')
'mainTable./Shórts - Blue (SB01)/.Product'.click()
'Suppliers'.shouldHaveCount(0)
'Back'.click()
'stocktend_purchaseOrders'.click()
'Add'.click()
  'Purchase Order Number'.shouldMatch('PO[0-9]*')
  'Purchase Order Number'.enter('PO00002')
  'Location'.shouldEqual('General')
  'Expected Delivery Date'.shouldEqualExpression('global.todayLocal()')
  'Supplier'.chooseOption('Castaways')
  'Expected Delivery Date'.enterExpression('global.todayLocal().incDays(7)')
  'Add Line'.click()
   'Product'.chooseOption('Shórts - Blue (SB01)')
   'Quantity'.enter('1')
  'OK'.click()
'Add another'.click()
  'Purchase Order Number'.enter('PO00003')
  'Location'.enter('WH01')
  'Supplier'.chooseOption('Bombast Corporation')
  'Expected Delivery Date'.enterExpression('global.todayLocal().incDays(5)')
  'Add Line'.click()
    'Product'.chooseOption('Shórts - Blue (SB01)')
    'Quantity'.enter('1')
    'Add another line'.click()
    'Product'.chooseOption('Hoodie (H01)')
    'Unit Price (Inc Tax)'.enter('16.00')
    'Quantity'.enter('10')
    'Add another line'.click()
    'Product'.chooseOption('Shórts - Red (SR01)')
    'Quantity'.enter('2')
    'Received Quantity'.shouldEqual('0')
    'Save'.click()
    'Back'.click()
  'Back'.click()
'Inventory'.click()
  'searcher'.enter('s')
  'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('2')
  'Location Inventory'.click()
    'Location'.shouldEqual('General')
    'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('1')
    'Location'.chooseOption('WH01')
    'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('1')
    'Back'.click()
  'searcher'.enter('h')
  'mainTable./Hoodie (H01)/.Quantity On Hand'.shouldEqual('0')
  'mainTable./Hoodie (H01)/.Edit Product'.click()
    'Last Purchase Unit Cost (Inc Tax)'.shouldEqual('16.00')
    'OK'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'mainTable./PO00003/.Edit'.click()
  'Location'.enter('General')
  'messageDialog'.shouldExist('doc')
  'messageDialogText'.shouldEqual("Location cannot be altered once purchase order lines have been added", 'doc')
  'messageDialogOK'.click('doc')
  'Back'.click()
'helper'.clearWCOrders()
'helper'.addWCOrder({product: 'Hoodie (H01)', quantity: 3, orderDate: global.todayLocal().incDays(-3), status: 'wc-pending'})
'helper'.addWCOrder({product: 'Hoodie (H01)', quantity: 1, orderDate: global.todayLocal().incDays(-18), status: 'wc-completed'})
'helper'.addWCOrder({product: 'Hoodie (H01)', quantity: 1, orderDate: global.todayLocal().incDays(-400), status: 'wc-processing'})
'Inventory'.click()
  'searcher'.enter('s')
  'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('2')
  'searcher'.enter('h')
  'mainTable./Hoodie (H01)/.Quantity On Hand'.shouldEqual('-2')
  'mainTable./Hoodie (H01)/.Adjust Qty'.click()
    'Quantity Change'.enter('3')
    'OK'.click()
  'mainTable./Hoodie (H01)/.Quantity On Hand'.shouldEqual('1')
  'mainTable./Hoodie (H01)/.Edit Product'.click()
    'Last Purchase Unit Cost (Inc Tax)'.shouldEqual('16.00')
    'OK'.click()
  'mainTable./Hoodie (H01)/.Product'.click()
    'Low Stock Threshold'.enter('13')
    'Add Supplier'.click()
      'Supplier'.enter('Castaways')
      'Is Main Supplier of Product'.enter('Yes')
      'OK'.click()
    'OK'.click()
  'searcher'.enter('s')
  'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('2')
  'mainTable./Shórts - Red (SR01)/.Product'.click()
    'Low Stock Threshold'.enter('3')
    'Maximum Quantity to Replenish To'.enter('50')
    'Add Supplier'.click()
      'Supplier'.enter('Castaways')
      'Is Main Supplier of Product'.enter('Yes')
      'OK'.click()
    'OK'.click()
  'mainTable./Shórts - Blue (SB01)/.Product'.click()
    'Low Stock Threshold'.enter('4')
    'Maximum Quantity to Replenish To'.enter('50')
    'Suppliers.0.Trash'.click()
    'Suppliers.0.Really Trash?'.click()
    'Add Supplier'.click()
      'Supplier'.enter('Castaways')
      'Is Main Supplier of Product'.enter('Yes')
      'OK'.click()
    'OK'.click()
  'searcher'.enter('')
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'View Short Stock'.click()
    'mainTable.0.Last 12 Weeks Sales'.shouldExist()
    'stocktend_settings'.click()
      'Weeks of Prior Sales to use for Sales Projections'.shouldEqual('12')
      'OK'.click()
    'Inventory'.click()
      'searcher'.enter('s')
      'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('2')
      'searcher'.enter('h')
      'mainTable./Hoodie (H01)/.Edit Product'.click()
        'Last Purchase Unit Cost (Inc Tax)'.shouldEqual('16.00')
        'OK'.click()
      'Back'.click()
    'mainTable.0.Product'.shouldEqual('Hoodie (H01)')
    'mainTable.0.Low Stock Threshold'.shouldEqual('13')
    'mainTable.0.On Purchase Orders'.shouldEqual('10')
    'mainTable.0.On Sales Orders'.shouldEqual('3')
    'mainTable.0.On Hand'.shouldEqual('1')
    'mainTable.0.Last 12 Weeks Sales'.shouldEqual('4')
    'stocktend_inventory'.click()
      'Customize'.click()
        'Add Field'.click()
          'Get Value From'.enter('Inventory.priorWeeksSalesUnits')
          'Caption'.enter('Prior Weeks Sales')
          'Display As'.enter('Number')
          'Minimum Decimals'.enter(0)
          'Maximum Decimals'.enter(0)
          'OK'.click()
        'Add Field'.click()
          'Get Value From'.enter('Inventory.totalSalesUnits')
          'Caption'.enter('Total Sales')
          'Display As'.enter('Number')
          'Minimum Decimals'.enter(0)
          'Maximum Decimals'.enter(0)
          'OK'.click()
        'OK'.click()
      'mainTable./Hoodie (H01)/.Prior Weeks Sales'.shouldEqual('4')
      'mainTable./Hoodie (H01)/.Total Sales'.shouldEqual('5')
      'Back'.click()
    'helper'.emulateDaysInFuture(84)
    'stocktend_inventory'.click()
      'mainTable./Hoodie (H01)/.Prior Weeks Sales'.shouldEqual('0')
      'mainTable./Hoodie (H01)/.Total Sales'.shouldEqual('5')
      'mainTable./Hoodie (H01)/.Edit Product'.click()
        'Last Purchase Unit Cost (Inc Tax)'.shouldEqual('16.00')
        'OK'.click()
      'Back'.click()
    'helper'.emulateDaysInFuture(0)
    'stocktend_inventory'.click()
      'mainTable./Hoodie (H01)/.Prior Weeks Sales'.shouldEqual('4')
      'Back'.click()
    'mainTable.0.Surplus'.shouldEqual('-5')
    'mainTable.0.Surplus Weeks'.shouldEqual('-15.00')
    'searcher'.enter('sh')
    'mainTable.0.Product'.shouldEqual('Shórts - Blue (SB01)')
    'mainTable.0.Surplus'.shouldEqual('-2')
    'mainTable.1.Product'.shouldEqual('Shórts - Red (SR01)')
    'mainTable.1.Surplus'.shouldEqual('-1')
    'Back'.click()
  'Back'.click()
'Inventory'.click()
  'searcher'.enter('')
  'mainTable./Hoodie (H01)/.Edit Product'.click()
    'Est Sales Units Per Day'.enter('0.1')
    'Last Purchase Unit Cost (Inc Tax)'.shouldEqual('16.00')
    'OK'.click()
  'Back'.click()
'Inventory'.click()
'helper'.clearWCOrders()
'helper'.addWCOrder({product: 'Hoodie (H01)', quantity: 3, orderDate: global.todayLocal().incDays(-3), status: 'wc-pending'})
'helper'.addWCOrder({product: 'Hoodie (H01)', quantity: 1, orderDate: global.todayLocal().incDays(-18), status: 'wc-pending'})
'helper'.flushCache()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('AutoTest')
    'Auto Lines - Min-Max'.click()
      'messageDialogText'.shouldEqual("Please select a Supplier before attempting to generate auto PO lines", 'doc')
      'messageDialogOK'.click('doc')
    'lines'.shouldHaveCount(0)
    'Supplier'.enter('Castaways')
    'Auto Lines - Min-Max'.click()
    'lines'.shouldHaveCount(3)
    'lines./Hoodie (H01)/.Quantity'.shouldEqual('6')
    'lines./Hoodie (H01)/.Line Total (Inc Tax)'.shouldEqual('96.00')
    'lines./Shórts - Blue (SB01)/.Quantity'.shouldEqual('48')
    'lines./Shórts - Red (SR01)/.Quantity'.shouldEqual('48')
    'OK'.click()
  'Inventory'.click()
    'searcher'.enter('s')
    'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('50')
    'Back'.click()
'View Short Stock'.click()
'searcher'.enter('h')
'mainTable./Hoodie (H01)/.Surplus'.shouldEqual('0')
'searcher'.enter('s')
'mainTable./Shórts - Blue (SB01)/.Surplus'.shouldEqual('46')
'mainTable./Shórts - Red (SR01)/.Surplus'.shouldEqual('47')
'searcher'.enter('')
'Back'.click()
'Purchase Orders'.shouldBeCurrentPage()
'mainTable./AutoTest/.Trash'.click()
'mainTable./AutoTest/.Really Trash?'.click()
'Inventory'.click()
'mainTable./Hoodie (H01)/.Adjust Qty'.click()
'Quantity Change'.enter('-1')
'OK'.click()
'Inventory'.click()
'mainTable./Hoodie (H01)/.View History'.click()
'mainTable.0.Reference'.click()
'View Inventory Adjustment'.shouldBeCurrentPage()
'Back'.click()
'Back'.click()
'mainTable./Belt (#33)/.View History'.click()
'Product'.shouldEqual('Belt (#33)');
'Back'.click()
'searcher'.enter('s')
'mainTable./Shórts - Red (SR01)/.On Purchase Orders'.shouldEqual('2')
'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('2')
'searcher'.enter('h')
'mainTable./Hoodie (H01)/.On Purchase Orders'.shouldEqual('10')
'Receive Purchases'.click()
'Receive Purchases'.shouldBeCurrentPage()
'mainTable'.shouldHaveCount(3) // Including Total
'mainTable.2.Purchase Order Number'.shouldEqual('PO00002')
'mainTable.2.Expected Delivery Date'.shouldEqualExpression('global.todayLocal().incDays(7).toLocalMMMDY()')
'mainTable.1.Purchase Order Number'.shouldEqual('PO00003')
'mainTable.1.Status'.shouldEqual('Awaiting Delivery')
'mainTable.1.Supplier'.shouldEqual('Bombast Corporation')
'mainTable.1.Enter Receipt'.click()
'Add Purchase Order Receipt'.shouldBeCurrentPage()
'browser'.back()
'Receive Purchases'.shouldBeCurrentPage()
'mainTable./PO00003/.Enter Receipt'.click()
  'Add Purchase Order Receipt'.shouldBeCurrentPage()
  'Receipt Number'.shouldEqual('PO00003-01')
  'Location'.shouldEqual('WH01')
  'Location'.shouldBeReadOnly()
  'Received Date'.shouldEqualExpression('global.todayLocal()')
  'Received Date'.enterExpression('global.todayLocal().incDays(-1)')
  'Lines'.shouldHaveCount(3)
  'Purchase Order'.shouldEqual('PO00003')
  'Purchase Order'.shouldBeReadOnly()
  'Supplier'.shouldBeReadOnly()
  'Supplier'.shouldEqual('Bombast Corporation')
  'helper'.generateDBErrorOnNextSave({datatype: 'POReceiptLine', index: 2})
  'Save'.click() // *****
  'stFormRejection'.shouldContain('Database error was generated for testing')
  'helper'.generateErrorOnNextSave()
  'Save'.click()
  'stFormRejection'.shouldContain('Save error was generated for testing')
  'helper'.generateErrorOnNextPreSave()
  'Save'.click()
  'stFormRejection'.shouldContain('Presave error was generated for testing')
  'Save'.click()
  'OK'.shouldntHaveError()
  'Inventory'.click()
    'searcher'.enter('s')
    'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('1')
    'Location Inventory'.click()
      'Location'.chooseOption('WH01')
      'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('0')
      'mainTable./Shórts - Blue (SB01)/.On Hand'.shouldEqual('1')
      'Location'.chooseOption('General')
      'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('1')
      'Back'.click()
    'Back'.click()
  'Edit Purchase Order Receipt'.shouldBeCurrentPage()
    'Lines'.shouldHaveCount(3)
    'Lines.0.Description'.shouldEqual('Shórts - Blue (SB01)')
    'Lines.0.Ordered'.shouldEqual('1')
    'Lines.0.Received'.shouldEqual('1')
    'Lines.2.Description'.shouldEqual('Shórts - Red (SR01)')
    'Lines.2.Ordered'.shouldEqual('2')
    'Lines.2.Received'.shouldEqual('2')
    'Lines.2.Previously Received'.shouldEqual('0')
    'Lines.2.Edit'.click()
      'Product'.shouldEqual('Shórts - Red (SR01)')
      'Product'.shouldBeReadOnly()
      'Received'.shouldEqual('2')
      'Received'.enter('1')
      'OK'.click()
    'Save'.shouldntHaveError()
'Inventory'.click()
'searcher'.enter('s')
'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('1')
'Back'.click()
'Edit Purchase Order Receipt'.shouldBeCurrentPage()
'Save'.click()
'Receive Purchases'.click()
'Receive Purchases'.shouldBeCurrentPage()
'mainTable.1.Purchase Order Number'.shouldEqual('PO00003')
'mainTable.1.Status'.shouldEqual('Partially Received')
'stocktend_purchaseOrders'.click()
'mainTable./PO00003/.Edit'.click()
'Lines./Shórts - Red (SR01)/.Edit'.click()
'Product'.chooseOption('Hoodie (H01)')
'OK'.click()
'stFormRejection'.shouldContain('You cannot change the product on a line that has been received or partially received')
'Back'.click()
'Yes - Cancel my changes'.click('doc')
'Inventory'.click()
'searcher'.enter('s')
'mainTable./Shórts - Red (SR01)/.On Purchase Orders'.shouldEqual('1')
'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('1')
'mainTable./Shórts - Red (SR01)/.Quantity On Hand'.shouldEqual('1')
'searcher'.enter('h')
'mainTable./Hoodie (H01)/.On Purchase Orders'.shouldEqual('0')
'searcher'.enter('s')
'mainTable./Shórts - Red (SR01)/.View History'.click()
'Inventory History'.shouldBeCurrentPage()
'mainTable.0.Date'.shouldEqualExpression('global.todayLocal().incDays(-1).toLocalMMMDY()')
'mainTable.0.Quantity'.shouldEqual('-1')
'mainTable.0.Balance'.shouldEqual('1')
'mainTable.0.Source'.shouldEqual('PO Receipt')
'mainTable.0.Reference'.shouldEqual('PO00003')
'mainTable.0.Reference'.click()
'Edit Purchase Order'.shouldBeCurrentPage()
'Purchase Order Number'.shouldEqual('PO00003')
'Back'.click()
'Receive Purchases'.click()
'mainTable./PO00003/.Enter Receipt'.click()
'Add Purchase Order Receipt'.shouldBeCurrentPage()
'Receipt Number'.shouldEqual('PO00003-02')
'Lines.0.Description'.shouldEqual('Shórts - Red (SR01)')
'Lines.0.Received'.shouldEqual('1')
'Lines.0.Previously Received'.shouldEqual('1')
'Lines.0.Edit'.click()
'Edit Receipt Line'.shouldBeCurrentPage()
'Received'.shouldEqual('1')
'Previously Received'.shouldEqual('1')
'Previously Received'.shouldBeReadOnly()
'Received'.enter('2')
'OK'.click()
'Add Purchase Order Receipt'.shouldBeCurrentPage()
'Inventory'.click()
'searcher'.enter('s')
'mainTable./Shórts - Red (SR01)/.Quantity On Hand'.shouldEqual('3')
'searcher'.enter('98765')
'mainTable'.shouldHaveCount(0)
'searcherClear'.click()
'searcher'.key('s')
'mainTable./Shórts - Red (SR01)/.Quantity On Hand'.shouldEqual('3')
'stocktend_purchaseOrders'.click()
'mainTable./PO00002/.Edit'.click()
'Status'.shouldEqual('Awaiting Delivery')
'Lines.0.Edit'.click()
'Quantity'.shouldEqual('1')
'Quantity'.enter('0')
'OK'.click()
'Edit Purchase Order'.shouldBeCurrentPage()
'Save'.click()
'helper'.addWCOrder({product: 'Hoodie (H01)', quantity: 2, orderDate: global.todayLocal().incDays(-3), status: 'wc-completed'})
'helper'.addWCOrder({product: 'Hoodie (H01)', quantity: 8, orderDate: global.todayLocal().incDays(-90), status: 'wc-completed'})
'Inventory'.click()
  'mainTable./Hoodie (H01)/.Prior Weeks Sales'.shouldEqual('6')
  'mainTable./Hoodie (H01)/.Total Sales'.shouldEqual('14')
  'Back'.click()
'stocktend_settings'.click()
  'Weeks of Prior Sales to use for Sales Projections'.enter('20')
  'OK'.click()
'Inventory'.click()
  'mainTable./Hoodie (H01)/.Prior Weeks Sales'.shouldEqual('14')
  'Back'.click()
'Back'.click()
'Back'.click()
'Back'.click()
'Back'.click()
'Back'.click()
'Back'.click()
'Back'.click()
'Back'.click()
'Back'.click()
'Back'.click()
'Back'.click()
'Back'.click()
'Back'.click()
'Back'.click()
'Back'.click()
